module.exports = __webpack_public_path__ + "img/editPen.a87f6419.svg";